import React, { ReactNode } from 'react';
import { CodeType } from '../CodeType';
import { BuildCodeParams, CodeSample } from './CodeSample';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';
import CodeBlock from '../CodeBlock';

export default class FrontendJavascriptSample extends CodeSample {
  name = 'Vanilla JS';
  language = 'javascript';
  codeType = CodeType.FRONTEND;
  tabIcon = '';
  commentChar = undefined;

  buildCode({ environment, notification, user }: BuildCodeParams): ReactNode {
    const importCode = `<script src="https://unpkg.com/notificationapi-js-client-sdk@4.1.0/dist/notificationapi-js-client-sdk.js"></script>
<link href="https://unpkg.com/notificationapi-js-client-sdk@4.1.0/dist/styles.css" rel="stylesheet" />`;

    const code = `const notificationapi = new NotificationAPI({
  clientId: '${environment.clientId}',
  userId: '${user.email}'
});

notificationapi.showInApp({
  root: 'CONTAINER-DIV-ID',
  popupPosition: 'topLeft'
});`;

    return (
      <>
        <Paragraph style={{ paddingTop: 10 }}>
          Import the NotificationAPI JS Client SDK:
        </Paragraph>
        <CodeBlock language="bash" code={importCode} />
        <Paragraph>
          Once the SDK is imported, you can add the following code within a{' '}
          <Text code>{`<script>`}</Text> element.
        </Paragraph>
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }
}
